import React from 'react';
import PropTypes from 'prop-types';
import { SurveyCreator, SurveyCreatorComponent } from 'survey-creator-react';

import 'survey-core/survey.i18n.js';
import 'survey-creator-core/survey-creator-core.i18n.js';
import 'survey-core/defaultV2.css';
import 'survey-creator-core/survey-creator-core.css';

const CustomSurveyCreator = ({ data, onEditFinish }) => {
  const creatorOptions = {
    showLogicTab: true,
  };

  const creator = new SurveyCreator(creatorOptions);
  creator.isAutoSave = false;
  creator.showState = true;
  creator.text = data.assessment;
  creator.saveSurveyFunc = () =>
    onEditFinish({
      id: data.id,
      data: creator.text,
    });

  return <SurveyCreatorComponent creator={creator} />;
};

CustomSurveyCreator.propTypes = {
  data: PropTypes.object,
  onEditFinish: PropTypes.func,
};

export default CustomSurveyCreator;
